




























import { Component, Prop, Vue } from 'vue-property-decorator'
import NavDrawerAccount from './NavDrawerAccount.vue'
import NavDrawerDGNDD from './NavDrawerDGNDD.vue'
import NavDrawerGstc from './NavDrawerGstc.vue'
import NavDrawerNhapLieu from './NavDrawerNhapLieu.vue'
import NavDrawerSummary from './NavDrawerSummary.vue'

@Component({
  components: {
    NavDrawerNhapLieu,
    NavDrawerGstc,
    NavDrawerDGNDD,
    NavDrawerAccount,
    NavDrawerSummary,
  }
})
export default class NavDrawer extends Vue {
  @Prop(Boolean) readonly drawer?: boolean

  get companies () {
    return this.$store.getters.getCompanies
  }
}
